import { render, staticRenderFns } from "./OtherRequiredFormsList.vue?vue&type=template&id=7d5a80a6"
import script from "./OtherRequiredFormsList.vue?vue&type=script&lang=ts"
export * from "./OtherRequiredFormsList.vue?vue&type=script&lang=ts"
import style0 from "./OtherRequiredFormsList.vue?vue&type=style&index=0&id=7d5a80a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports